var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearDashboard24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03843 10.6098C9 10.803 9 11.0353 9 11.5C9 11.9647 9 12.197 9.03843 12.3902C9.19624 13.1836 9.81644 13.8038 10.6098 13.9616C10.803 14 11.0353 14 11.5 14C11.9647 14 12.197 14 12.3902 13.9616C13.1836 13.8038 13.8038 13.1836 13.9616 12.3902C14 12.197 14 11.9647 14 11.5C14 11.0353 14 10.803 13.9616 10.6098C13.8038 9.81644 13.1836 9.19624 12.3902 9.03843C12.197 9 11.9647 9 11.5 9C11.0353 9 10.803 9 10.6098 9.03843C9.81644 9.19624 9.19624 9.81644 9.03843 10.6098Z",
    fill: "url(#paint0_linear_1_127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0384 10.6098C16 10.803 16 11.0353 16 11.5C16 11.9647 16 12.197 16.0384 12.3902C16.1962 13.1836 16.8164 13.8038 17.6098 13.9616C17.803 14 18.0353 14 18.5 14C18.9647 14 19.197 14 19.3902 13.9616C20.1836 13.8038 20.8038 13.1836 20.9616 12.3902C21 12.197 21 11.9647 21 11.5C21 11.0353 21 10.803 20.9616 10.6098C20.8038 9.81644 20.1836 9.19624 19.3902 9.03843C19.197 9 18.9647 9 18.5 9C18.0353 9 17.803 9 17.6098 9.03843C16.8164 9.19624 16.1962 9.81644 16.0384 10.6098Z",
    fill: "url(#paint1_linear_1_127)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5C2 11.0353 2 10.803 2.03843 10.6098C2.19624 9.81644 2.81644 9.19624 3.60982 9.03843C3.80302 9 4.03534 9 4.5 9C4.96466 9 5.19698 9 5.39018 9.03843C6.18356 9.19624 6.80376 9.81644 6.96157 10.6098C7 10.803 7 11.0353 7 11.5C7 11.9647 7 12.197 6.96157 12.3902C6.80376 13.1836 6.18356 13.8038 5.39018 13.9616C5.19698 14 4.96466 14 4.5 14C4.03534 14 3.80302 14 3.60982 13.9616C2.81644 13.8038 2.19624 13.1836 2.03843 12.3902C2 12.197 2 11.9647 2 11.5Z",
    fill: "url(#paint2_linear_1_127)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5C2 4.03534 2 3.80302 2.03843 3.60982C2.19624 2.81644 2.81644 2.19624 3.60982 2.03843C3.80302 2 4.03534 2 4.5 2C4.96466 2 5.19698 2 5.39018 2.03843C6.18356 2.19624 6.80376 2.81644 6.96157 3.60982C7 3.80302 7 4.03534 7 4.5C7 4.96466 7 5.19698 6.96157 5.39018C6.80376 6.18356 6.18356 6.80376 5.39018 6.96157C5.19698 7 4.96466 7 4.5 7C4.03534 7 3.80302 7 3.60982 6.96157C2.81644 6.80376 2.19624 6.18356 2.03843 5.39018C2 5.19698 2 4.96466 2 4.5Z",
    fill: "url(#paint3_linear_1_127)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9 4.03534 9 3.80302 9.03843 3.60982C9.19624 2.81644 9.81644 2.19624 10.6098 2.03843C10.803 2 11.0353 2 11.5 2C11.9647 2 12.197 2 12.3902 2.03843C13.1836 2.19624 13.8038 2.81644 13.9616 3.60982C14 3.80302 14 4.03534 14 4.5C14 4.96466 14 5.19698 13.9616 5.39018C13.8038 6.18356 13.1836 6.80376 12.3902 6.96157C12.197 7 11.9647 7 11.5 7C11.0353 7 10.803 7 10.6098 6.96157C9.81644 6.80376 9.19624 6.18356 9.03843 5.39018C9 5.19698 9 4.96466 9 4.5Z",
    fill: "url(#paint4_linear_1_127)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5C16 4.03534 16 3.80302 16.0384 3.60982C16.1962 2.81644 16.8164 2.19624 17.6098 2.03843C17.803 2 18.0353 2 18.5 2C18.9647 2 19.197 2 19.3902 2.03843C20.1836 2.19624 20.8038 2.81644 20.9616 3.60982C21 3.80302 21 4.03534 21 4.5C21 4.96466 21 5.19698 20.9616 5.39018C20.8038 6.18356 20.1836 6.80376 19.3902 6.96157C19.197 7 18.9647 7 18.5 7C18.0353 7 17.803 7 17.6098 6.96157C16.8164 6.80376 16.1962 6.18356 16.0384 5.39018C16 5.19698 16 4.96466 16 4.5Z",
    fill: "url(#paint5_linear_1_127)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00963 18.304C2 18.4017 2 18.5178 2 18.75C2 18.9822 2 19.0983 2.00963 19.196C2.10315 20.1456 2.85441 20.8968 3.80397 20.9904C3.90175 21 4.01783 21 4.25 21H18.75C18.9822 21 19.0983 21 19.196 20.9904C20.1456 20.8968 20.8968 20.1456 20.9904 19.196C21 19.0983 21 18.9822 21 18.75C21 18.5178 21 18.4017 20.9904 18.304C20.8968 17.3544 20.1456 16.6032 19.196 16.5096C19.0983 16.5 18.9822 16.5 18.75 16.5H4.25C4.01783 16.5 3.90175 16.5 3.80397 16.5096C2.85441 16.6032 2.10315 17.3544 2.00963 18.304Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5735 21H15.2969L12.4708 16.5H7.74732L10.5735 21ZM4.47225 16.5H4.25C4.01783 16.5 3.90175 16.5 3.80397 16.5096C2.85441 16.6032 2.10315 17.3544 2.00963 18.304C2 18.4017 2 18.5178 2 18.75C2 18.9822 2 19.0983 2.00963 19.196C2.10315 20.1456 2.85441 20.8968 3.80397 20.9904C3.90175 21 4.01783 21 4.25 21H7.29839L4.47225 16.5ZM15.7488 16.5L18.575 21H18.75C18.9822 21 19.0983 21 19.196 20.9904C20.1456 20.8968 20.8968 20.1456 20.9904 19.196C21 19.0983 21 18.9822 21 18.75C21 18.5178 21 18.4017 20.9904 18.304C20.8968 17.3544 20.1456 16.6032 19.196 16.5096C19.0983 16.5 18.9822 16.5 18.75 16.5H15.7488Z",
    fill: "url(#paint6_linear_1_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_127",
    x1: 9,
    y1: 9,
    x2: 14,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_127",
    x1: 16,
    y1: 9,
    x2: 21,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_127",
    x1: 2,
    y1: 9,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_127",
    x1: 2,
    y1: 2,
    x2: 7,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_127",
    x1: 9,
    y1: 2,
    x2: 14,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_127",
    x1: 16,
    y1: 2,
    x2: 21,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_127",
    x1: 21,
    y1: 16.5,
    x2: 18.9816,
    y2: 25.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearDashboard24);
export default __webpack_public_path__ + "static/media/newyear-dashboard_24.e2e1862b.svg";
export { ForwardRef as ReactComponent };